import React from "react";
import {
  Modal,
  Form,
  Divider,
  Space,
  Row,
  Col,
  Button,
  Input,
  Select,
} from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

const PrModal = ({
  isVipOpen,
  setIsVipOpen,
  handleTicketSend,
  genderOptions,
  isPrLoading,
}) => {
  return (
    <Modal
      title="設定公關票email"
      open={isVipOpen}
      footer={null}
      onCancel={() => setIsVipOpen(false)}
      width={800}
    >
      <Form
        name="dynamic_form_nest_item"
        onFinish={handleTicketSend}
        autoComplete="off"
      >
        <Divider />
        <Form.List name="details">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <>
                  <Space
                    key={key}
                    align="baseline"
                    className="[&_.ant-space-item:first-child]:grow"
                  >
                    <Row gutter={16}>
                      <Col span={6}>
                        <Form.Item {...restField} name={[name, "gender"]}>
                          <Select
                            options={genderOptions}
                            placeholder="gender"
                          ></Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item {...restField} name={[name, "age"]}>
                          <Input placeholder="age" />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, "name"]}
                          className="mb-0"
                        >
                          <Input placeholder="name" />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, "email"]}
                          className="mb-0"
                        >
                          <Input placeholder="email" />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          {...restField}
                          name={[name, "phone"]}
                          className="mb-0"
                        >
                          <Input placeholder="phone" />
                        </Form.Item>
                      </Col>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Row>
                  </Space>
                  <Divider />
                </>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  增加一筆 Add field
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isPrLoading}>
            送出
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PrModal;
